import {
  CombinedProtocolStatus,
  ProtocolName,
  useStatusTransitionMapQuery
} from '@/modules/protocol';
import { useMemo } from 'react';

export const useAvailableStatusTransitions = (
  protocol: ProtocolName,
  currentStatus?: CombinedProtocolStatus
) => {
  const { data: map, isLoading } = useStatusTransitionMapQuery();

  const availableTransitions = useMemo(() => {
    if (!currentStatus || !map) {
      return undefined;
    }

    return map[protocol]?.[currentStatus] ?? [];
  }, [map, protocol, currentStatus]);

  return {
    availableTransitions,
    isLoading
  };
};
